<template>
  <div
    id="parceiroModal"
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="mySmallModalLabel"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-green">
        <div class="modal-body rounded">
          <div class="row vertical-align">
            <div class="col-md-5">
              <img
                src="../../assets/images/fechadura.png"
                class="img-responsive"
              />
            </div>
            <div class="col-md-7 text-center">
              <h1 class="green-modal title-modal">
                {{ $t('modal_message') }}
              </h1>
              <button
                type="button"
                class="btn bg-green-modal green btn-modal"
                data-dismiss="modal"
                @click="handleClick()"
              >
                {{ $t('modal_button_message') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Modal',
  props: {
    arquivo: {
      type: Object,
      default() {
        return {
          Nome: 'O Arquivo selecionado'
        }
      }
    }
  },
  methods: {
    ...mapActions('lancamento', ['requestInteresse']),
    handleClick() {
      this.requestInteresse(this.arquivo.Nome)
    }
  }
}
</script>
